import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import {
  COVERAGE_AREA_FILTERS_MESSAGES,
  CoverageAreaFiltersMessages,
} from "./coverage-area-filters.messages";
import {
  COVERAGE_AREA_REQUEST_MESSAGES,
  CoverageAreaRequestMessages,
} from "./coverage-area-request.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";
import {
  COVERAGE_AREA_TABLE_MESSAGES,
  CoverageAreaTableMessages,
} from "./coverage-area-table.messages";
import {
  COVERAGE_AREA_DIALOG_MESSAGES,
  CoverageAreaDialogMessages,
} from "./coverage-area-dialog.messages";

export type CoverageAreaFormMessages = SidebarMessages &
  ActionButtonMessages &
  PopoverMessages &
  CoverageAreaFiltersMessages &
  CoverageAreaRequestMessages &
  TableColumnsMessages &
  CoverageAreaTableMessages &
  CoverageAreaDialogMessages & {
    // Titles
    pageTitle: string;
    breadCrumbTitle: string;
    createPageTitle: string;
    createCoverageAreaBreadCrumbTitle: string;
    updatePageTitle: string;
    updateCoverageAreaBreadCrumbTitle: string;
    coverageAreaTableTitle: string;
    addCoverageAreaButton: string;
    importCoverageAreasButton: string;
    coverageAreaCardTitle: string;

    // Errors
    errorRequiredCepStart: string;
    errorRequiredCepEnd: string;
    errorRequiredAreaDescription: string;
    errorRequiredStartWeight: string;
    errorRequiredEndWeight: string;
    errorRequiredFreightChargeOrder: string;
    errorRequiredFreightCostCarrier: string;
    errorRequiredRegionalDeliveryTime: string;

    errorInvalidStartWeight: string;
    errorInvalidEndWeight: string;
    errorInvalidFreightChargeOrder: string;
    errorInvalidFreightCostCarrier: string;
    errorInvalidRegionalDeliveryTime: string;

    // Labels & Placeholders
    cepStartLabel: string;
    cepStartPlaceholder: string;
    cepEndLabel: string;
    cepEndPlaceholder: string;
    areaDescriptionLabel: string;
    areaDescriptionPlaceholder: string;
    startWeightLabel: string;
    endWeightLabel: string;
    freightChargeOrderLabel: string;
    freightCostCarrierLabel: string;
    regionalDeliveryTimeLabel: string;
    freightTypeLabel: string;
    freightTypeNoneLabel: string;
    freeShippingFromLabel: string;
  };

export const COVERAGE_AREA_FORM_MESSAGES: CoverageAreaFormMessages = {
  // Titles
  pageTitle: "Áreas de abrangência",
  createPageTitle: "Criar Área de Abrangência",
  updatePageTitle: "Editar Área de Abrangência",
  coverageAreaTableTitle: "Listagem de Áreas de Abrangência",
  breadCrumbTitle: "Área de Abrangência",
  createCoverageAreaBreadCrumbTitle: "Criar Área de Abrangência",
  updateCoverageAreaBreadCrumbTitle: "Editar Área de Abrangência",
  addCoverageAreaButton: "Nova Área",
  importCoverageAreasButton: "Carregar Regiões",
  coverageAreaCardTitle: "Informações da Área",

  // Errors
  errorRequiredCepStart: "Por favor, insira o CEP inicial",
  errorRequiredCepEnd: "Por favor, insira o CEP final",
  errorRequiredAreaDescription: "Por favor, insira uma descrição",
  errorRequiredStartWeight: "Por favor, insira o peso inicial",
  errorRequiredEndWeight: "Por favor, insira o peso final",
  errorRequiredFreightChargeOrder: "Por favor, insira a ordem do frete",
  errorRequiredFreightCostCarrier: "Por favor, insira o custo do frete",
  errorRequiredRegionalDeliveryTime: "Por favor, insira o prazo de entrega regional",

  errorInvalidStartWeight: "Peso inicial inválido. Insira um número positivo.",
  errorInvalidEndWeight: "Peso final inválido. Insira um número positivo.",
  errorInvalidFreightChargeOrder:
    "Valor do frete cobrado (*Pedido) inválido. Insira um número positivo.",
  errorInvalidFreightCostCarrier:
    "Valor do frete pago (*Transportadora) inválido. Insira um número positivo.",

  errorInvalidRegionalDeliveryTime: "Prazo de entrega inválido. Insira um número positivo.",

  // Labels & Placeholders
  cepStartLabel: "CEP Inicial",
  cepStartPlaceholder: "Ex: 01000-000",
  cepEndLabel: "CEP Final",
  cepEndPlaceholder: "Ex: 09999-999",
  areaDescriptionLabel: "Descrição da área",
  areaDescriptionPlaceholder: "Ex: Região Sul",
  startWeightLabel: "Peso inicial (Kg)",
  endWeightLabel: "Peso final (Kg)",
  freightChargeOrderLabel: "Valor do frete cobrado (*Pedido)",
  freightCostCarrierLabel: "Valor do frete pago (*Transportadora)",
  regionalDeliveryTimeLabel: "Prazo de Entrega (dias)",
  freightTypeLabel: "Tipo de frete",
  freightTypeNoneLabel: "Nenhum",
  freeShippingFromLabel: "Frete gratuito a partir de",

  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...POPOVER_MESSAGES,
  ...COVERAGE_AREA_FILTERS_MESSAGES,
  ...COVERAGE_AREA_REQUEST_MESSAGES,
  ...TABLE_COLUMNS_MESSAGES,
  ...COVERAGE_AREA_TABLE_MESSAGES,
  ...COVERAGE_AREA_DIALOG_MESSAGES,
};

export default COVERAGE_AREA_FORM_MESSAGES;
